import { formaters } from "vincent-utils";

import { CadendarConsts } from "cadendar-shared";
const { getTypeConstFromTypeNumber, typeTranslator } = CadendarConsts;
import _ from "underts";
import {
  highlightedRdvAtom,
  selectedWeekAtom,
  useSelectedPatientIds,
} from "../../main/state/globalState";
import useOwner from "../../users/hooks/useOwner";
import { trpc } from "../../main/components/trpc.ts";
import { DateTime } from "luxon";
import Settings02Icon from "../../main/icons/settings-02-stroke-rounded.tsx";
import styles from "./ListRdvsPatient.module.css";
import { useEffect, useState } from "react";
import PatientSettingsPopup from "../../patients/components/PatientSettingsPopup.tsx";
import Badge from "../../main/components/Badge.tsx";
import { Button } from "@/components/ui/button";
import { useSetAtom } from "jotai";
import { toast } from "react-toastify";

const typeToColor = {
  [CadendarConsts.typeConsts.ANN]: "red" as const,
  [CadendarConsts.typeConsts.LAPIN]: "red" as const,
  [CadendarConsts.typeConsts.ANNTARD]: "red" as const,
} as { [key: number]: "red" }; //todo: fix this hack

const ListRdvsPatient = () => {
  const [patientIds] = useSelectedPatientIds();
  const owner = useOwner();
  const patientId = _.first(patientIds);
  const [showSettingsPopup, setShowSettingsPopup] = useState(false);
  const [settingsPopupTop, setSettingsPopupTop] = useState(0);
  const [settingsPopupLeft, setSettingsPopupLeft] = useState(0);
  const setSelectedWeek = useSetAtom(selectedWeekAtom);
  const setHighlightedRdv = useSetAtom(highlightedRdvAtom);
  const { data: rdvs } = trpc.rdv.findByPatientIds.useQuery(
    { patientIds: [patientId!] },
    { enabled: !!patientId },
  );
  // const [rdvs] = useSuperQuery(
  //   ["rdvs", "all", "byPatientId", patientId],
  //   getAllRdvs,
  //   [],
  //   { enabled: !!patientId },
  //   patientId
  // );
  // console.log("rdvs", rdvs);

  useEffect(() => {
    document.addEventListener("globalClick", () => {
      setShowSettingsPopup(false);
    });
    return () => {
      document.removeEventListener("globalClick", () => {
        setShowSettingsPopup(false);
      });
    };
  }, []);
  const handleShowSettingsPopup = (event: React.MouseEvent) => {
    event.stopPropagation();
    const target = event.currentTarget;
    setSettingsPopupTop(target.getBoundingClientRect().top);
    setSettingsPopupLeft(target.getBoundingClientRect().right + 10);
    setShowSettingsPopup((val) => !val);
  };

  const showRdvInAgenda = (rdv: {
    id: string;
    date: Date;
    archived: boolean;
  }) => {
    setSelectedWeek(DateTime.fromJSDate(rdv.date).startOf("week").toJSDate());
    if (rdv.archived) {
      setHighlightedRdv(null);
      toast.info(
        "Ce rendez-vous est archivé et n'est plus affiché dans l'agenda.",
      );
      return;
    }
    setHighlightedRdv((highlightedRdv) => ({
      id: rdv.id,
      requestId: (highlightedRdv?.requestId || 0) + 1,
    }));
  };

  const handleRdvKeyDown = (
    event: React.KeyboardEvent<HTMLTableRowElement>,
    rdv: { id: string; date: Date; archived: boolean },
  ) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      showRdvInAgenda(rdv);
    }
  };

  return (
    <>
      <div>
        <div className={styles.headerStyle}>
          <div className={styles.titleStyle}>Liste des rdvs</div>
          <Button
            className={styles.buttonStyle}
            data-testid="patientSettingsButton"
            size="icon"
            variant="ghost"
            title="Paramètres patient"
            onClick={handleShowSettingsPopup}
          >
            <Settings02Icon />
          </Button>
        </div>
        <div className={styles.centerer}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.th}>Date</th>
                <th className={styles.th}>Heure</th>
                <th className={styles.th}>Type</th>
                <th className={styles.th}>Objet</th>
              </tr>
            </thead>
            <tbody>
              {_.sortBy(
                rdvs || [],
                (rdv) =>
                  rdv.date.getTime() +
                  rdv.hour * 60 * 60 * 1000 +
                  rdv.minute * 1000,
              ).map((rdv) => (
                <tr
                  key={"rdvKey" + rdv.id}
                  className={styles.tr}
                  role="button"
                  tabIndex={0}
                  title="Afficher ce rendez-vous dans l'agenda"
                  onClick={() => showRdvInAgenda(rdv)}
                  onKeyDown={(event) => handleRdvKeyDown(event, rdv)}
                >
                  <td className={styles.td}>
                    {formaters.capitaliseEveryFirstLetter(
                      DateTime.fromJSDate(rdv.date).toLocaleString({
                        day: "2-digit",
                        month: "short",
                        year: "2-digit",
                      }),
                    )}
                  </td>
                  <td className={styles.td}>
                    {rdv.hour}h
                    {formaters.convertSingleDigitToTwoDigits(rdv.minute)}
                  </td>
                  <td className={styles.td}>
                    <Badge
                      text={
                        typeTranslator[getTypeConstFromTypeNumber(rdv.type)]
                      }
                      color={typeToColor[rdv.type]}
                    />
                  </td>
                  <td className={styles.td}>{rdv.object}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showSettingsPopup && patientId ? (
        <div
          className={styles.popupStyle}
          style={{ top: settingsPopupTop, left: settingsPopupLeft }}
        >
          <PatientSettingsPopup patientId={patientId} />
        </div>
      ) : null}
    </>
  );
};

export default ListRdvsPatient;
